var JustGage = require('justgage');

Vue.component('gauge', {
    props: ['current', 'target', 'target-against'],

    data () {
        return {
            id: 'chart-' + Math.random()
        };
    },

    mounted () {
        var displayCurrency = this.targetAgainst === 'value' || this.targetAgainst === undefined ? true : false;

        var gauge = new JustGage({
            id: this.id, // the id of the html element
            value: this.current,
            min: 0,
            max: this.target,
            decimals: 2,
            gaugeWidthScale: 0.6,
            counter: true,
            formatNumber: true,
            maxTxt: (displayCurrency ? '£' : '') + parseFloat(this.target).toLocaleString('en'),
            textRenderer (e) {
                return (displayCurrency ? '£' : '') + parseFloat(e).toLocaleString('en');
            },
            levelColors: ["#ff0000", "#f9c802", "#a9d70b"]
        });
    },

    template: `<div :id="id"></div>`
});